import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ChangePassword from './ChangePassword/ChangePassword';
import InviteMembers from './InviteMembers';

function Modal() {
    const [visible, setVisible] = useState(false);
    const { type, open: modalDisplay } = useSelector((state) => state.settings.modal);

    useEffect(() => {
        if(modalDisplay) {
            setVisible(true);
        }
        else {
            setVisible(false);
        }
    }, [modalDisplay]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center`}>
            {type === 'change-password' && <ChangePassword />}

            {type === 'invite-members' && <InviteMembers />}
        </div>
    );
}

export default Modal;
